import type { FaireProductEntity } from "../../entity_types/product";

export const p_56tg6myca8: FaireProductEntity = {
  token: "p_56tg6myca8",
  type: "product",
  name: "MUD WITCH MINI HOME BLIND BOX ASSORTMENT",
  brandToken: "b_3sbdu0huip",
  brandName: "MUD WITCH",
  imageUrl:
    "https://cdn.faire.com/fastly/0148c8326d6a8ca8b4963c45784407b687a363c2204abe4e7aaccc5c51987341.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4027c09304780536c933d52c06b2bec60e0fe17197e9e52ba5c57d0d2ee06110.jpeg",
    "https://cdn.faire.com/fastly/a407e21b7372da0dce0995a7707214e4b6d19cfec8fd23ea1f7c25d60f9c4f9e.jpeg",
    "https://cdn.faire.com/fastly/54b6991119dad8a81b9710c07e47e98c7265efeb3794d7c6fbd1c3c683908b80.jpeg",
    "https://cdn.faire.com/fastly/3ad39aa0e7184b683a4131fbc606b357b7b56924582fd6830c830c21a84f52cd.jpeg",
    "https://cdn.faire.com/fastly/72a226787a143e328cd66a1fd7bc3ec01f0660c1b6fbb21b2c6b0ff2e26789e3.jpeg",
    "https://cdn.faire.com/fastly/a10a7c9cb50fbe6dc54993507b70c0b7862c0099996d0c6096e4fe870da379f6.jpeg",
  ],
  priceDollars: 16.8,
  description:
    "Looking or some great add ons? Try these mini ceramics blind boxes! Different shapes and a variety of glaze finishes. Mini ramen bowls, cups, planters, matcha bowls, vases and more! All handmade! Think of it as a stylish ceramic surprise bag—yes, please.\n\nEach one is carefully curated within a dreamy color palette, so whatever lands on your doorstep, it’s going to look good. And let’s be honest—when it’s a mystery drop, people always want more than one.\n\nEach one comes in a house shaped box\nPrintable table topper available to entice customers and explain whats inside.\n\nDishwasher and microwave safe",
  tags: [],
  msrpDollars: 33.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:29.032Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
